import React from "react";
import "./SliderSmall.css";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import BanerSmall1 from "./Banners2/BanerSmall1";
import BanerSmall2 from "./Banners2/BanerSmall2";
import BanerSmall3 from "./Banners2/BanerSmall3";

export const SliderSmall = (props) => {
  const [pause, setPause] = React.useState(false);
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const timer = React.useRef();

  const [sliderRef, slider] = useKeenSlider({
    loop: true,
    initial: 0,
    controls: false,
    duration: 1000,
    dragStart: () => {
      setPause(true);
    },
    dragEnd: () => {
      setPause(false);
    },
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  React.useEffect(() => {
    sliderRef.current.addEventListener("mouseover", () => {
      setPause(true);
    });
    sliderRef.current.addEventListener("mouseout", () => {
      setPause(false);
    });
  }, [sliderRef]);

  React.useEffect(() => {
    timer.current = setInterval(() => {
      if (!pause && slider) {
        slider.next();
      }
    }, 80000);
    return () => {
      clearInterval(timer.current);
    };
  }, [pause, slider]);

  return (
    <div className="navigation-wrapper2">
      <div ref={sliderRef} className="keen-slider">
        <div className="keen-slider__slide number-slide1">
          <BanerSmall1></BanerSmall1>
        </div>
        <div className="keen-slider__slide number-slide2">
          <BanerSmall2></BanerSmall2>
        </div>
        <div className="keen-slider__slide number-slide3">
          <BanerSmall3></BanerSmall3>
        </div>
      </div>

      {slider && (
        <div className="dots9">
          {[...Array(slider.details().size).keys()].map((idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  slider.moveToSlideRelative(idx);
                }}
                className={"dot" + (currentSlide === idx ? " active" : "")}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
